import { theme } from '@agentisai/design-system';

/**
 * VersionStamp — a tiny, recede-by-default diagnostic stamp of the deployed
 * build version (git short SHA), fixed in the bottom-right corner (D4-08 /
 * versioning paper req 1). It is NOT chrome: token-driven, the faintest neutral
 * at low opacity, and `pointer-events: none` + `user-select: none` so it can
 * never intercept a click or compete with the app's TopNav / modals. Rendered
 * last at the app root (App.tsx) so it stacks above page content without a
 * z-index. No motion → reduced-motion-safe by construction.
 *
 * The value is the Vite-injected build constant `__APP_VERSION__` (`'dev'`
 * locally) — a build-time identity, so it is inlined (unlike the runtime
 * `config.json`, D4-06). The HTTP-queryable `/version.json` + the BFF
 * `/healthz` `version` carry the same value for tooling.
 */
export function VersionStamp() {
  return (
    <span
      data-testid="version-stamp"
      aria-label={`App build version ${__APP_VERSION__}`}
      style={{
        position: 'fixed',
        right: theme.space[3],
        bottom: theme.space[2],
        pointerEvents: 'none',
        userSelect: 'none',
        fontSize: theme.typography.fontSize.caption,
        fontWeight: theme.typography.fontWeight.regular,
        letterSpacing: theme.typography.letterSpacing.label,
        fontVariantNumeric: 'tabular-nums',
        color: theme.color.neutral.fainter,
        opacity: 0.6,
      }}
    >
      {__APP_VERSION__}
    </span>
  );
}
VersionStamp.displayName = 'VersionStamp';
